import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spec',
  templateUrl: './spec.component.html',
  styleUrls: ['./spec.component.scss'],
})
export class SpecComponent {
  @Input() key: string | undefined;

  @Input() value: string | undefined;

  // constructor() {}
}
